import { useAuth } from "@/context/AuthContext";

// Large-format area unit per tenant; engine stores area costs per m2, factor = units per m2.
export const LF_K = { sqft: 10.7639, sqm: 1, sqyd: 1.19599 };
export const useLfUom = () => useAuth().user?.tenant?.lf_uom || "sqft";
const kOf = (u) => LF_K[u] || LF_K.sqft;
const r4 = (n) => Math.round(n * 10000) / 10000;
export const perLf = (perM2, u) => r4(Number(perM2 || 0) / kOf(u));
export const lfText = (s, u) => (typeof s === "string" ? s.replace(/\bm2\b|m²|\bsqm\b/g, u) : s);
export const lfPrice = (m, u) => (m.unit === "m2" ? `${m.currency} ${perLf(m.cost, u)}/${u}` : `${m.currency} ${m.cost}/${m.unit}`);
// Show per-m2 fields in the tenant unit; unchanged values keep their stored precision on save.
export const toLf = (obj, keys, u) => ({ ...obj, ...Object.fromEntries(keys.filter((k) => obj?.[k] != null && obj[k] !== "").map((k) => [k, perLf(obj[k], u)])) });
export const fromLf = (edited, orig, keys, u) => ({ ...edited, ...Object.fromEntries(keys.filter((k) => edited[k] != null && edited[k] !== "").map((k) => [k, orig && edited[k] === perLf(orig[k], u) ? orig[k] : r4(Number(edited[k]) * kOf(u))])) });
